<template>
  <section :class="mainPanelClass">
    <header
      class="flex flex-row-wrap items-baseline md:items-start justify-between border-b border-gray-200"
      :class="[
        mainHeaderClass,
        !removeDefaultMargins ? 'mb-4' : '',
        !removeDefaultPaddings ? 'pb-2' : '',
        removeDefaultMargins && newMargin ? newMargin : '',
      ]"
    >
      <h2 :class="headingClass">
        <button
          :disabled="disabledPanel"
          :aria-controls="id"
          :aria-expanded="expanded"
          class="flex items-center text-lg md:text-xl"
          :class="[{ 'cursor-not-allowed': disabledPanel }, panelButtonClass]"
          @click="controlSection()"
        >
          <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="11"
            viewBox="0 0 20 11"
            fill="none"
            class="feather feather-chevron-down transition-transform transform"
            :class="{ 'rotate-down': expanded }"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.80586 4.40739L17.2134 10.9844L19.6113 8.67538L9.8181 -0.000335569L0.000396937 8.67537L2.38605 10.9844L9.80586 4.40739Z"
              fill="#1E264C"
            ></path>
          </svg>
          <span class="text-red-100 ml-1 mr-1 align-bottom">{{
            required
          }}</span>
          <span
            class="ml-1 text-sm font-semibold tracking-widest text-left uppercase"
            :class="panelButtonTextClass"
            data-cy="titleForm"
          >
            <slot name="titleText">
              {{ title }}
            </slot>
          </span>
        </button>
      </h2>
      <div class="md:hidden basis-full"></div>
      <div
        v-if="hasPanelHeaderCheckboxSlot"
        class="flex justify-center text-gray-600"
        :class="[
          !removeDefaultMargins ? 'mb-4' : '',
          { 'md:order-none mt-4': hasPanelHeaderItemSlot },
        ]"
      >
        <slot name="panelHeaderCheckbox" />
      </div>
      <div class="basis-full hidden md:block"></div>
      <slot v-if="expanded" name="panelHeaderItem" />
    </header>
    <div
      :id="id"
      :class="panelContentClass"
      :style="{ display: expanded === true ? 'grid' : 'none' }"
      v-if="!removeContentOnHidden || expanded"
    >
      <slot name="content" />
    </div>
  </section>
</template>
<script>
export default {
  name: "FormPanel",
  props: {
    required: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    initiallyExpanded: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: "someid",
      required: false,
    },
    panelContentClass: {
      type: String,
      default: "pb-6 text-sm text-gray-600 border-gray-200",
    },
    mainPanelClass: {
      type: String,
      default: "",
    },
    panelButtonTextClass: {
      type: String,
      default: "",
    },
    mainHeaderClass: {
      type: String,
      default: "",
    },
    disabledPanel: {
      type: Boolean,
      default: false,
    },
    removeDefaultMargins: {
      type: Boolean,
      default: false,
    },
    removeDefaultPaddings: {
      type: Boolean,
      default: false,
    },
    newMargin: {
      type: String,
      default: "",
    },
    panelButtonClass: {
      type: String,
      default: "",
    },
    headingClass: {
      type: String,
      default: "",
    },
    removeContentOnHidden: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["panelExpandedEvent"],
  data() {
    return {
      expanded: null,
    };
  },
  computed: {
    hasCardImageSlot() {
      return typeof this.$slots.cardImage === "function";
    },
    hasPanelHeaderCheckboxSlot() {
      return typeof this.$slots.panelHeaderCheckbox === "function";
    },
    hasPanelHeaderItemSlot() {
      return typeof this.$slots.panelHeaderItem === "function";
    },
  },
  watch: {
    initiallyExpanded(newVal) {
      this.expanded = newVal;
    },
  },
  created() {
    this.expanded = this.initiallyExpanded;
  },
  methods: {
    controlSection() {
      this.$emit("panelExpandedEvent", !this.expanded);
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.flex-row-wrap {
  flex-flow: row wrap;
}
.basis-full {
  flex-basis: 100%;
}
</style>
